export default __webpack_public_path__ + "static/media/userIcon.724b79cd.png";